import Layout from '@layout/Index'

export const midan = [
  {
    path: '/midan',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "midan-table" */ './pages/MidanTable.vue'),
        name: '米单列表',
        meta: {
          title: '米单列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "midan-form" */ './pages/MidanForm.vue'),
        name: '添加米单',
        meta: {
          title: '添加米单',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "midan-form" */ './pages/MidanForm.vue'),
        name: '修改米单',
        meta: {
          title: '修改米单',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "midan-detail" */ './pages/MidanDetail.vue'),
        name: '米单详情',
        meta: {
          title: '米单详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/midan/midan.route.js